import { FormattedMessage } from 'react-intl';

import { Typography } from '@mui/material';

import { getBathroomCount } from '@arrived/common';
import { Property } from '@arrived/models';

import { Numeral } from '../../../Numeral';

interface PropertyDetailsHouseInfoProps {
  property?: Property;
}

export const PropertyDetailsHouseInfo = ({ property }: PropertyDetailsHouseInfoProps) => {
  if (!property) return null;
  const { bedrooms, squareFootage, yearBuilt } = property;

  return (
    <Typography variant="body2" textTransform="uppercase" data-e2e="property-details-house-info-wrapper">
      <FormattedMessage
        id="property-details-house-info-message"
        defaultMessage="bed: {bedroomCount} &nbsp;&nbsp; bath: {bathroomCount} &nbsp;&nbsp; sq ft: {squareFootage} &nbsp;&nbsp; year built: {yearBuilt}"
        values={{
          yearBuilt,
          bedroomCount: bedrooms,
          bathroomCount: getBathroomCount(property),
          squareFootage: <Numeral value={squareFootage ?? 0} />,
        }}
      />
    </Typography>
  );
};
